import React, { Component } from "react";
import axios from "axios";
import * as appConst from "./constants";

import "react-inputs-validation/lib/react-inputs-validation.min.css";

import { AutoComplete } from "primereact/autocomplete";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import subMonths from "date-fns/subMonths";
import addMonths from "date-fns/addMonths";
import { InputText } from "primereact/inputtext";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";
import { TabView, TabPanel } from 'primereact/tabview';
import { Editor } from 'primereact/editor';
import { InputTextarea } from "primereact/inputtextarea";
import { SelectButton } from "primereact/selectbutton";

class TestUpload extends Component {
  constructor(props) {
    super(props);
    this.state = { validTill: "", todayAPI: "" };
  }

  componentDidMount() {
    axios
      .get(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) + "/center/edit"
      )
      .then(response => {
        this.setState({
          validTill: response.data.validTill,
          todayAPI: response.data.todayAPI
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  render() {
    return (
      <div>
        <h3 align="center">Support</h3>
        <div className="container-fluid">
          <div className="row p-1 border">
            <input type="file" onChange={this.fileChangedHandler} />
            <button onClick={this.uploadHandler}>Upload</button>
          </div>
        </div>
      </div>
    );
  }


  fileChangedHandler = event => {
    this.setState({ selectedFile: event.target.files[0] })
  }

  uploadHandler = () => {
    const formData = new FormData();
    formData.append(
      'myFile',
      this.state.selectedFile,
      this.state.selectedFile.name,
    )

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/testupload/",
        formData
      )
      .then(res => {
        this.setState({ selectedFile: null });
        alert(res.data);

      });
  }
}

export default TestUpload;
